module.exports = __webpack_public_path__ + "img/consta.7f6bd761.svg";